import { render } from "./CallConfigNumbers.vue?vue&type=template&id=94777342"
import script from "./CallConfigNumbers.vue?vue&type=script&lang=js"
export * from "./CallConfigNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__